<template>
        <!-- container -->
        <div id="main-container-earth" style="height: 100vh;">

            <!-- logo -->
            <img id="vitrafyEarth-logo" src="../assets/images/LifeChain_Logo_Inverted.png" @click="logoClick()"/>
            
            <!-- expand and compress icons -->
            <div id="fullscreen-button" class="app-button" @click="GoInFullscreen()"><i class="fa-solid fa-expand"></i></div>
            <div id="exit-button" class="app-button" @click="GoOutFullscreen()"><i class="fa-solid fa-compress"></i></div>
            
            <!-- earth  -->
            <canvas id="canvasOne" style="width: 100%; height: 100%; background-color: black;">
                Your browser does not support HTML5 Canvas.
            </canvas>

            <!-- controls -->
            <div id="earth-controls">
                <!-- <b-form-checkbox switch v-model="labelsEnabled">Show Labels</b-form-checkbox> -->
                <!-- <b-form-checkbox switch v-model="coordinatesEnabled">Show Coordinates</b-form-checkbox> -->
                <!-- <b-form-checkbox switch v-model="controlsEnabled">Show Controls</b-form-checkbox> -->
                <b-form-checkbox switch v-model="flyOverEnabled">Fly Over</b-form-checkbox>
                <b-form-checkbox switch v-model="autoRotateEnabled">Orbit</b-form-checkbox>
            </div>

        </div>
        <!-- END container -->
</template>
 
<script>
    const WorldWind = require('@nasaworldwind/worldwind')

    export default {
        name: "Earth",
        data() {
            return {
                wwd: null,
                BingAerialWithLabelsLayer: null,
                labelsEnabled: false,
                CoordinatesDisplayLayer: null,
                coordinatesEnabled: false,
                ViewControlsLayer: null,
                starFieldLayer: null,
                atmosphereLayer: null,
                controlsEnabled: false,
                autoRotateEnabled: true,
                orbitInterval: null,
                orbitTimer: 0,
                startAutoOrbitAgainAfter: 12000, // 5 min (2400 is 1 min)
                flyOverEnabled: false,
                earthAnimationDuration: 160, // 4 sec
                earthAnimationDurationCounter: this.earthAnimationDuration,
                earthAnimationWait: 2400, // 1 min
                earthAnimationWaitCounter: 0,
                currentRange: null,
                flyOverRange: 0,
                defaultRange: 23000000,
                degreeCount: 0,
                degreeTarget: 90,
            };
        },    
        mounted() {
            // Display core vue app element
            const appElement = document.getElementById('app');
            appElement.style.display = 'block';

            // Create a WorldWindow for the canvas.
            this.wwd = new WorldWind.WorldWindow("canvasOne");

            // Layers
            // ------
            // Coordinates layer
            this.CoordinatesDisplayLayer = new WorldWind.CoordinatesDisplayLayer(this.wwd);
            this.CoordinatesDisplayLayer.enabled = this.coordinatesEnabled;
            this.wwd.addLayer(this.CoordinatesDisplayLayer);

            // controls
            this.ViewControlsLayer = new WorldWind.ViewControlsLayer(this.wwd);
            this.ViewControlsLayer.enabled = this.controlsEnabled;
            this.wwd.addLayer(this.ViewControlsLayer );

            // base layer (image)
            var BMNGOneImageLayer = new WorldWind.BMNGOneImageLayer();
            this.wwd.addLayer(BMNGOneImageLayer);

            // more detailed layer
            var BMNGLayer = new WorldWind.BMNGLayer();
            this.wwd.addLayer(BMNGLayer);

            // Bing Aerial Layer
            var BingAerialLayer = new WorldWind.BingAerialLayer(null);
            BingAerialLayer.maxActiveAltitude = 5e6;
            this.wwd.addLayer(BingAerialLayer);

            // Bing Aerial With Labels Layer
            this.BingAerialWithLabelsLayer = new WorldWind.BingAerialWithLabelsLayer(null);
            this.BingAerialWithLabelsLayer.enabled = false;
            this.wwd.addLayer(this.BingAerialWithLabelsLayer);

            // Star Field Layer
            this.starFieldLayer = new WorldWind.StarFieldLayer();
            this.starFieldLayer.enabled = true;
            this.wwd.addLayer(this.starFieldLayer);
            
            // Atmosphere Layer
            this.atmosphereLayer = new WorldWind.AtmosphereLayer();
            this.atmosphereLayer.enabled = true;
            this.atmosphereLayer.minActiveAltitude = 5e6;
            this.wwd.addLayer(this.atmosphereLayer);

            // set time for Star Field and Atmosphere layers
            var now = new Date();
            this.starFieldLayer.time = now;
            this.atmosphereLayer.time = now;

            // Starting position
            // -----------------
            // Adjust the Navigator to custom location (pacific ocean)
            this.wwd.navigator.lookAtLocation.latitude = 0;
            this.wwd.navigator.lookAtLocation.longitude = 150;
            this.wwd.navigator.range = 23e6; // 2 million meters above the ellipsoid

            // Pins (Placeholders)
            // -------------------
            var pinLibrary = WorldWind.WWUtil.currentUrlSansFilePart() + "/images/pushpins/", // location of the image files
            placemark,
            placemarkAttributes = new WorldWind.PlacemarkAttributes(null),
            highlightAttributes,
            placemarkLayer = new WorldWind.RenderableLayer("Placemarks");

            // Set up the common placemark attributes.
            placemarkAttributes.imageScale = 0.5;

            placemarkAttributes.imageOffset = new WorldWind.Offset(
                WorldWind.OFFSET_FRACTION, 0.5,
                WorldWind.OFFSET_FRACTION, 0.0);

            placemark = new WorldWind.Placemark(new WorldWind.Position(-37.556545360013075, 143.8503359570268, 1e2), false, null);
            //placemark.label = "Ballarat (Vitrafy Lab)";
            placemark.altitudeMode = WorldWind.CLAMP_TO_GROUND;
            placemark.alwaysOnTop = true;
            placemark.imageTilt = 0.5;
            placemark.imageTiltReference = WorldWind.RELATIVE_TO_GLOBE;
            placemarkAttributes = new WorldWind.PlacemarkAttributes(placemarkAttributes);
            placemarkAttributes.imageSource = pinLibrary + "plain-red.png";
            placemark.attributes = placemarkAttributes;
            highlightAttributes = new WorldWind.PlacemarkAttributes(placemarkAttributes);
            highlightAttributes.imageScale = 1.2;
            placemark.highlightAttributes = highlightAttributes;
            placemarkLayer.addRenderable(placemark);    

            placemark = new WorldWind.Placemark(new WorldWind.Position(29.48690752342053, -98.5399355306852, 1e2), false, null);
            // placemark.label = "Texas (BioBridge Global)";
            placemark.altitudeMode = WorldWind.CLAMP_TO_GROUND;
            placemark.alwaysOnTop = true;
            placemark.imageTilt = 0.5;
            placemark.imageTiltReference = WorldWind.RELATIVE_TO_GLOBE;        
            placemarkAttributes = new WorldWind.PlacemarkAttributes(placemarkAttributes);
            placemarkAttributes.imageSource = pinLibrary + "plain-red.png";
            placemark.attributes = placemarkAttributes;
            highlightAttributes = new WorldWind.PlacemarkAttributes(placemarkAttributes);
            highlightAttributes.imageScale = 1.2;
            placemark.highlightAttributes = highlightAttributes;
            placemarkLayer.addRenderable(placemark);

            placemark = new WorldWind.Placemark(new WorldWind.Position(-33.86706078406797, 151.21761927042604, 1e2), false, null);
            // placemark.label = "Sydney (Australian Red Cross Lifeblood)";
            placemark.altitudeMode = WorldWind.CLAMP_TO_GROUND;
            placemark.alwaysOnTop = true;
            placemark.imageTilt = 0.5;
            placemark.imageTiltReference = WorldWind.RELATIVE_TO_GLOBE;        
            placemarkAttributes = new WorldWind.PlacemarkAttributes(placemarkAttributes);
            placemarkAttributes.imageSource = pinLibrary + "plain-red.png";
            placemark.attributes = placemarkAttributes;
            highlightAttributes = new WorldWind.PlacemarkAttributes(placemarkAttributes);
            highlightAttributes.imageScale = 1.2;
            placemark.highlightAttributes = highlightAttributes;
            placemarkLayer.addRenderable(placemark);
            
            placemark = new WorldWind.Placemark(new WorldWind.Position(-42.882528544149736, 147.32611015266903, 1e2), false, null);
            // placemark.label = "Hobart (Huon Aquaculture)";
            placemark.altitudeMode = WorldWind.CLAMP_TO_GROUND;
            placemark.alwaysOnTop = true;
            placemark.imageTilt = 0.5;
            placemark.imageTiltReference = WorldWind.RELATIVE_TO_GLOBE;        
            placemarkAttributes = new WorldWind.PlacemarkAttributes(placemarkAttributes);
            placemarkAttributes.imageSource = pinLibrary + "plain-red.png";
            placemark.attributes = placemarkAttributes;
            highlightAttributes = new WorldWind.PlacemarkAttributes(placemarkAttributes);
            highlightAttributes.imageScale = 1.2;
            placemark.highlightAttributes = highlightAttributes;
            placemarkLayer.addRenderable(placemark);   

            // USA OFFICE
            placemark = new WorldWind.Placemark(new WorldWind.Position(33.65981766521007, -117.741215116961, 1e2), false, null);
            // placemark.label = "Hobart (Huon Aquaculture)";
            placemark.altitudeMode = WorldWind.CLAMP_TO_GROUND;
            placemark.alwaysOnTop = true;
            placemark.imageTilt = 0.5;
            placemark.imageTiltReference = WorldWind.RELATIVE_TO_GLOBE;        
            placemarkAttributes = new WorldWind.PlacemarkAttributes(placemarkAttributes);
            placemarkAttributes.imageSource = pinLibrary + "plain-red.png";
            placemark.attributes = placemarkAttributes;
            highlightAttributes = new WorldWind.PlacemarkAttributes(placemarkAttributes);
            highlightAttributes.imageScale = 1.2;
            placemark.highlightAttributes = highlightAttributes;
            placemarkLayer.addRenderable(placemark);              


            // Add the placemarks layer to the WorldWindow's layer list.
            this.wwd.addLayer(placemarkLayer);
            
            this.wwd.redraw();

            console.log("worldwind loaded!");

            // Orbit (on by default)
            this.runOrbitSimulation();

            // Event Listerners
            // ----------------
            // mouse down
            this.wwd.addEventListener("mousedown", (event) => {
                this.orbitTimer = 0;

                if(this.autoRotateEnabled) {
                    this.autoRotateEnabled = false;
                }
                
                var type = "mouse"
                var x = event.clientX;
                var y = event.clientY;

                // debug
                console.log("type = " + type);
                console.log("x = " + x);
                console.log("y = " + y);
            });

            // touch start
            this.wwd.addEventListener("touchstart", (event) => {
                this.orbitTimer = 0;

                if(this.autoRotateEnabled) {
                    this.autoRotateEnabled = false;
                }

                var type = "touch"
                var x = event.touches[0].pageX;
                var y = event.touches[0].pageX;

                // debug
                console.log("type = " + type);
                console.log("x = " + x);
                console.log("y = " + y);
            });

        },
        watch: {
            // show/hide layers
            coordinatesEnabled() {
                this.CoordinatesDisplayLayer.enabled = this.coordinatesEnabled;
                this.wwd.redraw();
            },
            labelsEnabled() {
                this.BingAerialWithLabelsLayer.enabled = this.labelsEnabled;
                this.wwd.redraw();
            },
            controlsEnabled() {
                this.ViewControlsLayer.enabled = this.controlsEnabled;
                this.wwd.redraw();
            },
            autoRotateEnabled() {
                this.orbitTimer = 0;
            },
            flyOverEnabled() {
                if(this.flyOverEnabled) {
                    this.earthAnimationDurationCounter = 0;
                    this.earthAnimationWaitCounter = 0;

                    this.wwd.navigator.lookAtLocation.latitude = 0;
                    this.wwd.navigator.lookAtLocation.longitude = 150;
                    this.wwd.navigator.heading = 90;
                    this.wwd.navigator.range = 8000000;
                    this.wwd.navigator.tilt = 60;
                    this.wwd.navigator.roll = 0;

                    this.wwd.redraw();
                } else {
                    this.wwd.navigator.lookAtLocation.latitude = 0;
                    this.wwd.navigator.lookAtLocation.longitude = 150;
                    this.wwd.navigator.heading = 0;
                    this.wwd.navigator.range = 23000000;
                    this.wwd.navigator.tilt = 0;
                    this.wwd.navigator.roll = 0;
                    
                    this.wwd.redraw();
                }
            }
        },
        created() {
        },    
        methods: {
            logoClick() {
                location.href="/lifelink"
            },            
            GoInFullscreen() {
                document.getElementById("fullscreen-button").style.display = 'none';
                document.getElementById("exit-button").style.display = 'block';

                var element = document.getElementById("main-container-earth");
                
                if(element.requestFullscreen)
                    element.requestFullscreen();
                else if(element.mozRequestFullScreen)
                    element.mozRequestFullScreen();
                else if(element.webkitRequestFullscreen)
                    element.webkitRequestFullscreen();
                else if(element.msRequestFullscreen)
                    element.msRequestFullscreen();
            },
            GoOutFullscreen() {
                document.getElementById("fullscreen-button").style.display = 'block';
                document.getElementById("exit-button").style.display = 'none';

                if(document.exitFullscreen)
                    document.exitFullscreen();
                else if(document.mozCancelFullScreen)
                    document.mozCancelFullScreen();
                else if(document.webkitExitFullscreen)
                    document.webkitExitFullscreen();
                else if(document.msExitFullscreen)
                    document.msExitFullscreen();

                this.wwd.redraw();
            },
            runOrbitSimulation() {
                this.orbitInterval = setInterval(() => {
                    var now = new Date();
                    this.starFieldLayer.time = now;
                    this.atmosphereLayer.time = now;

                    // orbit
                    if(this.autoRotateEnabled) {
                        this.wwd.navigator.lookAtLocation.longitude = this.wwd.navigator.lookAtLocation.longitude + 0.1;
                        this.wwd.redraw();
                    } else {
                        if(this.orbitTimer == this.startAutoOrbitAgainAfter) {
                            this.autoRotateEnabled = true;
                        }
                    }

                    // fly over
                    if(this.flyOverEnabled) {
                        // wait 10 sec then animate
                        if(this.earthAnimationWaitCounter != this.earthAnimationWait) {
                           // console.log("earthAnimationWaitCounter = " + this.earthAnimationWaitCounter);
                            this.earthAnimationWaitCounter++;
                        } else {
                            // add 90 degrees
                            if(this.degreeCount != this.degreeTarget) {

                                // Works
                                //this.wwd.navigator.roll = this.wwd.navigator.roll + 1;

                                // new version
                                var t = this.degreeCount;
                                var b = this.wwd.navigator.roll;
                                var c = 1;
                                var d = 89;

                                // normal
                                //this.wwd.navigator.roll = c * t / d + b;

                                // Quadratic easing in
                                //this.wwd.navigator.roll = c * (t /= d) * t + b;

                                // Quadratic easing out
                                this.wwd.navigator.roll = -c * (t /= d) * (t - 2) + b;
                                
                                // Circular easing out
                                //this.wwd.navigator.roll = c * Math.sqrt(1 - (t = t / d - 1) * t) + b;

                                this.degreeCount = this.degreeCount + 1;
                            } else {
                                console.log("this.wwd.navigator.rol = " + this.wwd.navigator.roll);
                                console.log("this.wwd.navigator.rol rounded = " + Math.round(this.wwd.navigator.roll));

                                this.wwd.navigator.roll = Math.round(this.wwd.navigator.roll);

                                this.earthAnimationWaitCounter = 0;
                                this.degreeCount = 0;
                            }
                        }
                    }

                    this.orbitTimer++;
                }, 25)
            },
        },
    };
</script>

<style>
    body {
        overflow-y: hidden !important; /* Hide vertical scrollbar */
        overflow-x: hidden !important; /* Hide horizontal scrollbar */
    }

    #earth-controls {
        color: white;
        position: absolute;
        bottom: 10px;
        left: 10px;
    }

    #exit-button {
        display: none;
        color: white;
        margin-top: 10px;
    }

    .app-button {
        position: absolute;
        top: 0;
        right: 0;
        margin: 20px !important;
        color: white;
        cursor: pointer;
    }

    #earth-controls,
    .custom-control-label {
        cursor: pointer;
    }

    #vitrafyEarth-logo {
        cursor: pointer;
    }    
</style>
